// import { packagesActions } from '@src/store/reducers/packagesReducer';
import { Component } from '@angular/core';
import { Store } from '@src/store';
import moment from 'moment';
import { reportsActions } from '@src/store/reducers/reportsReducer';
import { projectsActions } from "../../../../store/reducers/projectsReducer";

@Component({
    selector: 'reports-audit',
    template: require('./reports-audit.component.html'),
    styles: [require('./reports-audit.component.scss')]
})
export class ReportsAuditComponent {
  public _filters: any
  public tableData:any
  public pageId:number = 1
  public loadOnce:boolean = true;
constructor(private store: Store){
this.store.dispatch({ type: projectsActions.GET_PROJECTS_WITH_DEPLOY_STATUS });
}

public filter(filter) {
    this._filters = filter;
    this.getRecords();
}

getDataProjectsWithDeployStatus(){
    this.store.dispatch({ type: projectsActions.GET_PROJECTS_WITH_DEPLOY_STATUS });
}

public getRecords (page = 0) {
    this.pageId = page || 1;
    this.loadOnce = true;
    let fromDate = moment(this._filters.data.fromDate);
    let toDate = moment(this._filters.data.toDate);
    if (this._filters.fromDate) {
        fromDate.startOf('day')
    }
    if (this._filters.toDate) {
        toDate.endOf('day');
    }
    const payload = {
        "Filters": [   
                this.getFilter('ProjectIds', this._filters.data.project.id),
                this.getFilter('EnvironmentIds', Array.isArray(this._filters.data.env.id) ? this._filters.data.env.id.join() : this._filters.data.env.id),
                this.getFilter('SchemeIds', (this._filters.data.schema) ? this._filters.data.schema.id : null),
                this.getFilter('ObjectNames', (this._filters.data.objectNameFilter) ? this._filters.data.objectNameFilter : ''),
                this.getFilter('SearchType', (this._filters.data.objectName) ? this._filters.data.objectName.id : '-1'),
                this.getFilter('FromDate', (this._filters.data.fromDate) ? fromDate.toDate() : null),
                this.getFilter('ToDate', this._filters.data.toDate ? toDate.toDate() : null),
                this.getFilter('ShowAllowed', (this._filters.data.allowedOperation) ? 'True' : 'False'),
                this.getFilter('ShowDisallowed', (this._filters.data.blockedOperation) ? 'True' : 'False')
            
        ]

       , Page: page,
         Count: 15,
    };
    let type = reportsActions.GET_AUDIT_REPORT_DETAILS;
    this.store.dispatch({ type: type, payload: {
    data: payload
    } }).then((res) => {
        if (res) {
            this.tableData = res
        }
    });
    this.pageId += 1;
}

getFilter(filterName, value) {
    return {
        "FilterName": filterName,
        "Value": value
    }
}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/reports/report-details-an7/reports-audit.component.ts